import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { queryClient } from "../../../../../../../utils/queryClient";
//primereact
import { Button } from "primereact/button";
//components
import Input from "../../../../../../../components/input/Input";
import Modal from "../../../../../../../components/modal/Modal";
import Select from "../../../../../../../components/input/Select";
import TextareaInput from "../../../../../../../components/input/TextareaInput";
import FileInput from "../../../../../../../components/input/FileInput";
//services
import { postDocumentsContract } from "../../../../../../../services/Contracts/postDocumentsContract";

export const ModalDocuments = ({
  visible,
  setVisible,
  defaultValues,
  idSale,
  idClient,
}) => {
  const formFile = useForm({ defaultValues });
  const errorsFile = formFile.formState.errors;
  const [document, setDocument] = useState("");
  const [loading, setLoading] = useState(false);

  const { mutateAsync: postDocumentsFn } = useMutation({
    mutationFn: postDocumentsContract,
    onSuccess(dataDocuments, variables) {
      queryClient.setQueryData([`files${idSale}`], (data) => {
        const newDoc = dataDocuments.data.success.doc;
        if (variables.client_id) {
          data.clientFiles = [...data.clientFiles, newDoc];
        }
        return data;
      });
    },
  });

  useEffect(() => {
    formFile.setValue("file_name", "");
    formFile.setValue("desc", "");
    formFile.setValue("optionsDocument", defaultValues.optionsDocument);
  }, [defaultValues]);

  const selectOptions = [
    { value: "1", label: "Venda" },
    { value: "2", label: "Cliente" },
  ];

  const handleSubmitFile = async (data) => {
    const notification = toast.loading("Por favor aguarde...");
    setLoading(true);

    switch (data.optionsDocument) {
      case "1":
        data.sale_id = idSale;
        data.type = "sale";
        break;
      case "2":
        data.client_id = idClient;
        data.type = "client";
        break;
      default:
        break;
    }
    delete data.optionsDocument;
    data.file = document;
    //    console.log(data);
    //    console.log(document);
    if (!document) {
      toast.update(notification, {
        render: "Documento inválido!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
      return;
    }
    try {
      await postDocumentsFn(data);
      toast.update(notification, {
        render: "Documento Cadastrado com Sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
      setLoading(false);
    }

    setVisible(false);
  };

  return (
    <Modal
      visible={visible}
      dynamicTitle={"Anexo de Arquivos"}
      onHide={() => setVisible(false)}
      position="center"
    >
      <form onSubmit={formFile.handleSubmit(handleSubmitFile)}>
        <div className="row">
          <div className="card p-3 bg-cyan-300 rounded-3 bg-opacity-75">
            <span className="text-blue-800">
              <i className="fa-solid fa-circle-info me-1"></i>
              <b>Atenção</b>: Anexe os arquivos no tipo <b>correspondente</b> de
              cada arquivo.
            </span>
          </div>
        </div>
        <Select
          name="optionsDocument"
          preValue={defaultValues.optionsDocument}
          label="Selecione o local do documento"
          isRequired={true}
          errors={errorsFile}
          control={formFile.control}
          options={selectOptions}
        />
        <Input
          name="file_name"
          errors={errorsFile}
          control={formFile.control}
          isRequired={true}
          label={`Nome do Arquivo*`}
        />
        <div className="col-md-12 mt-4">
          <TextareaInput
            name="desc"
            label="Descrição do arquivo*"
            errors={formFile.errors}
            control={formFile.control}
            isRequired={true}
          />
        </div>
        <FileInput
          name="archive"
          setSelectedFile={setDocument}
          base64={true}
          doc="Arquivo"
          icon="fa-file"
        />
        <div className="d-flex justify-content-end mt-4">
          <Button
            label="Cancelar"
            type="button"
            onClick={() => setVisible(false)}
            icon="pi pi-times"
            loading={loading}
            className="p-button-text"
          />
          <Button
            label="Criar"
            type="submit"
            icon="pi pi-check"
            loading={loading}
            autoFocus
          />
        </div>
      </form>
    </Modal>
  );
};
